import React, { useEffect, useContext } from 'react';
import { Typography, Button } from '@material-ui/core';
import queryString from 'query-string';
import { getTokenDataRequest } from '../reducers/Auth/actions';

const Callback = props => {
  const { context, history } = props;
  const store = useContext(context);
  const state = store.getState();
  const { settings } = state;
  const { search } = state.router.location;
  const { pathname } = state.router.location;
  const token = !!localStorage.getItem('OSS_Token');

  useEffect(() => {
    const { code } = queryString.parse(search);
    if (code && !localStorage.getItem('OSS_Token')) {
      store.dispatch(getTokenDataRequest({ code, settings }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getTokenDataRequest, search, settings, store]);

  useEffect(() => {
    const redirectUrl = localStorage.getItem('redirectUrl');
    if (redirectUrl && token && pathname === '/callback') {
      history.push(redirectUrl);
    }
  }, [history, pathname, token]);

  return token ? (
    <div
      style={{
        position: 'fixed',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
      }}
    >
      <Typography gutterBottom component="span">
        Ако не бъдете пренасочени автоматично моля натиснете бутона
        <Button
          variant="contained"
          color="secondary"
          style={{ width: '100%' }}
          onClick={() => history.push('/')}
        >
          Начало
        </Button>
      </Typography>
    </div>
  ) : (
    <React.Fragment />
  );
};

export default Callback;
